import { useEffect, useState } from 'react'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { supportService } from '../services/supportService'
import { GetAllSupportsParams } from '../services/supportService/getAllSupports'

export const useGetAllSupports = ({ enabled = true } = {}) => {
  const [params, setParams] = useState<GetAllSupportsParams | undefined>({})
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['getAllSupports', params],
    queryFn: async () => supportService.getAllSupports(params),
    placeholderData: keepPreviousData,
    enabled,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
  }
}
